import { trackCxFoundationsSelfServiceInitView } from "@faire/web-api/events/cxFoundations/view/selfServiceInit";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Dropdown } from "@faire/web/slate/Input/Dropdown";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { useEffect } from "react";
import { DropdownGroups } from "../components/DropdownGroups";
import { NotBrandNorRetailerMessage } from "../components/NotBrandNorRetailerMessage";
import { useLoggedOutIssuesDropdown } from "../hooks/useLoggedOutIssuesDropdown";
import { useLoggedOutUserType } from "../hooks/useLoggedOutUserType";
import { CUSTOMER_TYPE_PROMPT_MESSAGE, getCustomerTypeList } from "../shared-text";
export var LoggedOutSelectTopicView = function LoggedOutSelectTopicView() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var customerListType = getCustomerTypeList(strictLocalize);
  var _useLoggedOutUserType = useLoggedOutUserType(),
    user = _useLoggedOutUserType.user,
    isKnownUserType = _useLoggedOutUserType.isKnownUserType,
    isUnknownUserType = _useLoggedOutUserType.isUnknownUserType;
  var _useLoggedOutIssuesDr = useLoggedOutIssuesDropdown(),
    handleUserDropdown = _useLoggedOutIssuesDr.handleUserDropdown;
  useEffect(function () {
    trackCxFoundationsSelfServiceInitView("", "");
  }, []);
  return /*#__PURE__*/React.createElement(Column, {
    justify: "flex-start",
    "data-test-id": "logged-out-select-topic-view"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "pageHeaderSerifRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "M6PcEI",
    defaultMessage: [{
      "type": 0,
      "value": "How can we help you?"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "GYKybb",
    defaultMessage: [{
      "type": 0,
      "value": "We need a bit more info to connect you with the right customer support team."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Dropdown, {
    value: user,
    placeholder: CUSTOMER_TYPE_PROMPT_MESSAGE(strictLocalize),
    options: customerListType,
    onSelect: handleUserDropdown,
    "data-test-id": "retailer-or-brand-dropdown"
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), isKnownUserType ? /*#__PURE__*/React.createElement(DropdownGroups, null) : null, /*#__PURE__*/React.createElement(NotBrandNorRetailerMessage, {
    visible: isUnknownUserType
  }));
};